export function getRefVariableMap(
  records: Record<string, any>[],
  varNameKey: string,
  expKey: string,
): Record<string, string[]> {
  return records.reduce(
    (obj, col) => {
      let varName = col[varNameKey];
      if (typeof varName === 'number') {
        varName = varName.toString();
      } else if (typeof varName !== 'string') {
        throw new Error('The variable name is not string');
      }
      const expression = col[expKey];
      obj[varName] = expression ? getRefVariables(expression) : [];
      return obj;
    },
    {} as Record<string, string[]>,
  );
}

export function getRefVariables(expression: string) {
  const refs = expression.match(/\{[^{}]+\}/g) || [];
  const reRefs = refs.map((ref) => ref.replace(/[{}]/g, ''));
  return [...new Set(reRefs)];
}

export function isCyclicReference(
  nodeMap: Record<string, string[]>,
): boolean {
  const visited = new Set<string>();
  const recStack = new Set<string>();
  const dfs = (node: string): boolean => {
    visited.add(node);
    recStack.add(node);
    const refNodes = nodeMap[node];
    if (!refNodes) {
      throw new Error('The referent node does not exist in nodeMap');
    }
    for (const refNode of refNodes) {
      if (
        (!visited.has(refNode) && dfs(refNode)) ||
        recStack.has(refNode) // found cycle
      ) {
        return true;
      }
    }
    recStack.delete(node);
    return false;
  };
  for (const node of Object.keys(nodeMap)) {
    if (!visited.has(node) && dfs(node)) {
      return true;
    }
  }
  return false;
}
